module.exports = __webpack_public_path__ + "img/pop_icon01.a5721721.jpg";